import type { NewFundCommandData } from '@festina/unitlink-general-types/unitlink'
import { FundSourcesCommandsService } from '@festina/unitlink-general-types/unitlink/services/FundSourcesCommandsService'
import { useFestinaMutation } from '@festina-life/authentication'
import { assertNotEmpty } from '@festina-life/core'

const method = FundSourcesCommandsService.fundSourcesServicePostCommands

type Props = {
  tenantId: string
}

type TriggerProps = NewFundCommandData

export const useCreateNewFund = ({ tenantId }: Props) =>
  useFestinaMutation({
    component: 'unitLink',
    roles: FundSourcesCommandsService.fundSourcesServicePostCommands_roles,
    isScenario: false,
    mutateFunction: async (arg: TriggerProps) => {
      assertNotEmpty(arg.isinKey)
      await method({
        xTenantId: tenantId,
        isinKey: arg.isinKey,
        requestBody: {
          _type: 'CreateFundCommand',
          commandType: 'newFund',
          commandData: arg,
        },
      })
    },
  })
